module.exports = __webpack_public_path__ + "static/img/bg.104755f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scm/bg.png
// module id = 8ZzR
// module chunks = 1